'use strict';

const _ = require('underscore');
const Moment = require('moment');
const Tooltip = require('common/ui/view/behavior/tooltip');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
require('jquery-ui/ui/widgets/sortable');
require('backbone.stickit');
require('bootstrap-material-design');
const ActionUpdateService = require('process/app/service/action/update');
const EmptyItem = require('common/ui/view/empty-item');
const Template = require('process/ui/template/action/item.hbs');
const DropZoneTemplate = require('process/ui/template/action/dropzone.hbs');
const CommentsCounterView = require('communication/ui/comment/view/counter');
const TasksCounterView = require('communication/ui/view/task/counter');

const ItemView = Mn.View.extend({
    template: Template,
    behaviors: [Tooltip],
    className: function() {
        let classes = 'list-item ';

        classes += `process-${this.model.id} `;

        const viewState = this.getOption('viewState');
        const target = viewState && viewState.getTarget();
        if (target && target.id === this.model.id) {
            classes += 'is-active ';
        }

        return classes;
    },
    tagName: 'li',
    ui: {
        caret: '.action-caret'
    },
    regions: {
        children: '.children',
        commentsCounter: '.comments-counter',
        tasksCounter: '.tasks-counter',
    },
    events: {
        'click > .list-item-icon > .action-caret': 'toggle',
        'click > .list-item-content': 'select'
    },
    modelEvents: {
        'change': 'render',
        'change:parent': 'destroy',
        'change:deleted': 'destroy'
    },
    // サブアクションで発生したイベントを上位のアクション一覧Viewに伝搬させる
    childViewTriggers: {
        'action:item:activated': 'action:item:activated'
    },
    // サブアクションで発生した要素選択イベントを受けて、必要であれば親アクションを展開状態にする
    childViewEvents: {
        'action:item:activated': 'changeChildIsActive'
    },

    initialize: function() {
        this._isOpen = false;

        const viewState = this.getOption('viewState');
        if (viewState) {
            viewState.on('change', () => {
                const target = viewState.getTarget();
                this.onRenderActiveHighlights(target);
            });
        }
    },

    templateContext: function() {
        const assignees = this.getSortedAssignees();
        const dispAssigneesNum = 5;
        const dispAssignees = new Backbone.Collection(_.first(assignees, dispAssigneesNum));

        return {
            isDelayed: this.model.isDelayed(),
            path: this.model.path(),
            state: this.model.getCurrentState().toJSON(),
            noChildren: this.getOption('noChildren'),
            sort: this.getOption('sortMode'),
            draggable: this.getOption('relateMode') || this.getOption('sortMode'),
            assignee: assignees.length > 0 ? assignees[0].toJSON() : null,
            dispAssignees: dispAssignees.length > 0 ? dispAssignees.toJSON() : null,
            moreAssigneesNum: assignees.length > dispAssigneesNum ? assignees.length - dispAssigneesNum : null
        }
    },

    // 担当者に自分が入っている時は先頭にする
    getSortedAssignees: function() {
        const user = this.getOption('context').getUser();
        let assignees = this.model.getAssignees();

        if(assignees.length > 0) {
            const index = _.findIndex(assignees, assignee => {
                return assignee.id == user.id;
            });
            if(index) {
                const assignedUser = assignees.splice(index, 1);
                assignees.unshift(assignedUser[0]);
            }
        }

        return assignees;
    },

    onRenderActiveHighlights: function(target) {
        // 自分自身の選択状態を反映
        if (target && target.id === this.model.id) {
            this.$el.addClass('is-active');
            this.$('.children').addClass('parent-is-active');
            this.trigger('action:item:activated', this.model);
        } else {
            this.$el.removeClass('is-active');
            this.$('.children').removeClass('parent-is-active');
        }

        this.changeChildIsActive(target);
    },

    changeChildIsActive: function(target) {
        if (target && this.model === target.getParent()) {
            this.$el.addClass('child-is-active');
        } else {
            this.$el.removeClass('child-is-active');
        }
    },

    onRender: function() {
        const context = this.getOption('context');
        const appInfo = context.getAppInfo();
        const projectID = context.getProject().id.toString();

        // 特定のプロジェクトは、アクション数が非常に多く、表示に時間がかかりすぎるため、
        // コメント数・タスク数の表示を無効化する
        const disabledProjectIDs = {
            "balus-local": {
                "4997452146933760": "テスト"
            },
            "balus-dev": {
                "5147254872604672": "アクション一覧のカウンター非表示のプロジェクト"
            },
            "balus-app": {
                "6268709962252288": "SSSRC > OPUSAT-II ひろがり"
            }
        };
        const projectIDs = _.keys(disabledProjectIDs[appInfo.getAppID()] || {});
        const communicationCounterDisabled = _.contains(projectIDs, projectID);

        if (communicationCounterDisabled) {
            this.$('.action-communication-counter').hide();
        } else {
            this.onRenderCommunicationCounter();
        }

        // サブアクションを表示するモードで、自身が選択中アクションの親アクションに当たる場合には、
        // 自身のサブアクション一覧を展開表示する (選択中アクションにたどり着けるようにする)
        const showChildren = !this.getOption('noChildren');
        const viewState = this.getOption('viewState');
        const target = viewState && viewState.getTarget();
        if (showChildren && target && this.model.isAncestorOf(target)) {
            this.open();
        }

        this.model.getChildren()
            .then(children => {
                if(children.length > 0) {
                    this.renderExpansionIndicator();
                }
                this.listenTo(children, 'add', () => {
                    this.renderExpansionIndicator();
                    this.open();
                });
            });

        this.onRenderActiveHighlights(target);

        $(this.el).data('backbone-view', this);
    },

    onRenderCommunicationCounter: function() {
        const context = this.getOption('context');
        const project = context.getProject();

        this.showChildView('commentsCounter', new CommentsCounterView({
            icon: 'fa fa-comments-o',
            project: project,
            key: this.model.key,
            hasComment: this.model.hasComment(),
        }));

        this.showChildView('tasksCounter', new TasksCounterView({
            icon: 'fa fa-check-square',
            project: project,
            key: this.model.key,
            hasTask: this.model.hasTask(),
        }));
    },

    onDomRefresh: function() {
        if(this.model.getUpdatedAt().add(5, 's').isAfter(Moment())) {
            this.$('.list-item-content').addClass('accent-diminishing');

            setTimeout(() => {
                this.$('.list-item-content').removeClass('accent-diminishing');
            }, 5000);
        }
    },

    renderExpansionIndicator: function() {
        // TODO: 配下のアクションが0件になった場合に、インジケータを非表示にする。
        // TODO: 現状の実装では、アクション削除時に Collection からエンティティは削除されず、 delete フラグが変化するだけで、
        // アクション削除をコレクションイベントとして扱いづらい。 Collection, 同時編集などを整理するとともに対応する。
        $(this.ui.caret, this.$el).show();
    },

    select: function() {
        if(this.getOption('noChildren')) {
            return;
        }
        this.open();
    },

    toggle: function() {
        if(this.getOption('noChildren')) {
            return;
        }
        if(!this._isOpen) {
            this.open();
        } else {
            this.close();
        }

    },

    open: function() {
        this.model.getChildren()
            .then(children => {
                this.showChildView('children', new (ListView.extend({
                    className: 'list list-sub',
                    emptyView: null,
                }))({
                    collection: children,
                    context: this.getOption('context'),
                    user: this.getOption('user'),
                    group: this.getOption('group'),
                    viewState: this.getOption('viewState'),
                    relateMode: this.getOption('relateMode'),
                    sortMode: this.getOption('sortMode'),
                    hideDropZone: true,
                    // サブアクションのリストでは smartScroll を無効化する (最上位のリストのみ有効化する)
                    smartScrollEnabled: false,
                }));
            });
        this._isOpen = true;
        $(this.ui.caret, this.$el).removeClass('fa-caret-right');
        $(this.ui.caret, this.$el).addClass('fa-caret-down');
    },

    close: function() {
        this.getRegion('children').empty();
        this._isOpen = false;
        $(this.ui.caret, this.$el).addClass('fa-caret-right');
        $(this.ui.caret, this.$el).removeClass('fa-caret-down');
    }
});

const ItemRelateView = ItemView.extend({
    onRender: function() {
        const viewState = this.getOption('viewState');
        const target = viewState && viewState.getTarget();
        if(!this.getOption('noChildren') &&
            target && this.model.isAncestorOf(target)){
            this.toggle();
        }

        this.$el.draggable({
            revert: true,
            revertDuration: 200,
            axis: 'y',
            zIndex: 10000
        });
        $(this.el).data('backbone-view', this);

        this.$el.droppable({
            greedy: true,
            classes: {
                'ui-droppable-hover': 'is-highlighted'
            },
            drop: (event, ui) => {
                const view = $(ui.draggable).data('backbone-view');
                if(!view) {
                    return;
                }

                this.onDropAction(view.model);
                event.stopPropagation();
            }
        });

        this.model.getChildren()
            .then(children => {
                if(children.length > 0) {
                    this.renderExpansionIndicator();
                }
                this.listenTo(children, 'add', () => {
                    this.renderExpansionIndicator();
                    this.open();
                });
            });
    },

    onDropAction(action) {
        let j = action.toJSON();
        j.parent = this.model.id;
        const oldParent = action.getParent();
        if(j.parent == oldParent.id) {
            return;
        }
        (new ActionUpdateService(
            action.getProject(), action.id, j
        ))
            .update()
            .then(() => {
                oldParent.removeChild(action);
            });
    }
});

const DropView = Mn.View.extend({
    template: DropZoneTemplate,
    className: 'action-dropzone',
    onRender: function() {
        this.$el.droppable({
            greedy: true,
            classes: {
                'ui-droppable-hover': 'is-highlighted',
                'ui-droppable-active': 'is-droppable'
            },
            drop: (event, ui) => {
                const view = $(ui.draggable).data('backbone-view');
                if(!view) {
                    return;
                }

                this.onDropAction(view.model);
                event.stopPropagation();
            }
        });
    },

    onDropAction(action) {
        let j = action.toJSON();
        const oldParent = action.getParent();
        j.parent = this.model.id;
        if(j.parent == oldParent.id) {
            return;
        }
        (new ActionUpdateService(
            action.getProject(), action.id, j
        ))
            .update()
            .then(() => {
                oldParent.removeChild(action);
            });
    }
});

const ListView = Mn.CollectionView.extend({
    relateMode: false,
    hideDropZone: false,
    childView: function() {
        if(this.getOption('relateMode')) {
            return ItemRelateView;
        } else {
            return ItemView;
        }
    },
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            user: this.getOption('user'),
            group: this.getOption('group'),
            viewState: this.getOption('viewState'),
            noChildren: this.getOption('noChildren'),
            relateMode: this.getOption('relateMode'),
            sortMode: this.getOption('sortMode'),
            // smartScroll は最上位のリストでのみ有効化し、サブアクションのリストに対しては smartScroll を有効化しない
            smartScrollEnabled: false,
        };
    },
    emptyView: EmptyItem,
    emptyViewOptions: function() {
        return {
            isList: true,
            title: i18n.t('process:action-list.no-child')
        };
    },
    tagName: 'ul',
    className: 'list',
    reorderOnSort: true,
    collectionEvents: {
        'change': 'render',
        'update': 'render',
        'change:point': 'reorder',
    },
    // サブアクションで発生したイベントを上位のアクション一覧Viewに伝搬させる
    childViewTriggers: {
        'action:item:activated': 'action:item:activated'
    },
    // 伝搬してきたアクションを受けてハンドリングする
    childViewEvents: {
        'action:item:activated': 'onActionItemActivated'
    },

    filter: function(child) {
        return !child.isDeleted();
    },
    viewComparator: function(child) {
        return child.getSortPosition();
    },

    onRender: function() {
        const relateMode = this.getOption('relateMode');
        const sortMode = this.getOption('sortMode');
        const hideDropZone = this.getOption('hideDropZone');
        if(relateMode && !hideDropZone && !this.dropZone) {
            this.dropZone = new DropView({model: this.model});
            this.$el.prepend((this.dropZone.render().el));
        }

        if(sortMode) {
            this.$el.sortable({
                axis: 'y',
                update: (event, ui) => {
                    this.onSortAction($(ui.item));
                }
            });
        }
    },

    onSortAction: function($item) {
        const action = $item.data('backbone-view').model;
        const prev = $item.prev().length > 0 ? $item.prev().data('backbone-view').model : null;
        const next = $item.next().length > 0 ? $item.next().data('backbone-view').model : null;

        let sortPosition;
        const sortIncrement = 655536;
        if(prev && next) {
            sortPosition = (prev.getSortPosition() + next.getSortPosition()) / 2;
        } else if(prev) {
            sortPosition = prev.getSortPosition() + sortIncrement;
        } else {
            sortPosition = next.getSortPosition() - sortIncrement;
        }

        let j = action.toJSON();
        j.sortPosition = sortPosition;
        (new ActionUpdateService(
            action.getProject(), action.id, j
        ))
            .update();
    },

    onActionItemActivated: function() {
        // smartScrollのイベントをハンドリングするのは、最上位のアクション一覧Viewだけ。
        const smartScrollEnabled = this.getOption('smartScrollEnabled');
        if (!smartScrollEnabled) {
            return;
        }

        this.smartScroll();
    },

    smartScroll: function(retryCount = 0) {
        const viewState = this.getOption('viewState');
        if (!viewState || !viewState.getTarget()) {
            return;
        }
        const targetProcessID = viewState.getTarget().id;
        const item = $(`.list-item.is-active.process-${targetProcessID} .list-item-content`);

        // 対象のDOMが見つからない場合（サブアクションだと複数回のAPI呼び出し後にレンダリングされるので遅延する）には、
        // 一定時間待ってから一定回数までリトライする
        if (item.length === 0 && retryCount < 10) {
            retryCount += 1;
            _.delay(() => {
                this.smartScroll(retryCount);
            }, 500);
        }

        if (item && item[0] && item[0].scrollIntoViewIfNeeded) {
            item[0].scrollIntoViewIfNeeded(false);
        }
    }
});

module.exports = ListView;



// WEBPACK FOOTER //
// ./process/ui/view/action/list.js